var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYaadeinBlankLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4638 242.606L223.303 140.003C234.432 133.581 234.437 117.52 223.312 111.092L45.5347 8.38083C34.4091 1.95295 20.4972 9.97936 20.4933 22.8285L20.4312 228.144C20.4273 240.993 34.3343 249.028 45.4638 242.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.391 125.821L133.922 72.9723C135.278 70.1924 136.27 67.4516 137.015 64.7571L65.3188 23.334C67.6662 31.3755 72.8395 42.4432 75.2739 48.6218L107.391 125.821Z",
    fill: "url(#paint0_linear_45_21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1149 170.146L39.3949 54.1688C33.1984 39.2062 28.1368 29.0852 24.0958 22.4033C23.927 23.3069 23.8086 24.2327 23.8081 25.2029L23.7563 196.031C45.6287 203.264 75.167 185.812 87.1149 170.146Z",
    fill: "url(#paint1_linear_45_21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.404 112.936L144.106 68.8545L95.5712 166.221C85.0982 187.437 67.2038 222.009 30.0337 238.545C34.5198 241.723 40.6887 242.464 46.1276 239.327L220.396 138.783C230.346 133.042 230.35 118.683 220.404 112.936Z",
    fill: "url(#paint2_linear_45_21)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M73.1099 214.391C73.1099 214.391 218.313 127.383 220.191 127.169C222.068 126.954 211.234 108.481 198.716 113.946C186.199 119.411 73.1099 214.391 73.1099 214.391Z",
    fill: "url(#paint3_linear_45_21)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M29.5317 64.876C29.5317 64.876 35.0379 183 34.5306 184.193C34.0232 185.386 48.9143 190.92 49.7334 181.485C50.5526 172.049 29.5317 64.876 29.5317 64.876Z",
    fill: "url(#paint4_linear_45_21)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M77.2344 35.8516C77.2344 35.8516 122.059 79.8945 126.533 70.3833C126.811 69.7919 131.087 68.2562 127.56 65.0391C124.033 61.8222 77.2344 35.8516 77.2344 35.8516Z",
    fill: "url(#paint5_linear_45_21)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_21",
    x1: 206.09,
    y1: 42.5324,
    x2: -10.4954,
    y2: 100.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F39320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1149,
    stopColor: "#EE5922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#E91E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2724,
    stopColor: "#E81C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    stopColor: "#E4136B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#BA267A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    stopColor: "#6C4B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    stopColor: "#466EA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9421,
    stopColor: "#139EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_21",
    x1: 211.352,
    y1: 62.1932,
    x2: -5.2336,
    y2: 120.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F39320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1149,
    stopColor: "#EE5922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#E91E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2724,
    stopColor: "#E81C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    stopColor: "#E4136B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#BA267A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    stopColor: "#6C4B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    stopColor: "#466EA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9421,
    stopColor: "#139EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_21",
    x1: 226.6,
    y1: 119.172,
    x2: 10.0146,
    y2: 177.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#F39320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1149,
    stopColor: "#EE5922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2362,
    stopColor: "#E91E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2724,
    stopColor: "#E81C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    stopColor: "#E4136B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#BA267A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    stopColor: "#6C4B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    stopColor: "#466EA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9421,
    stopColor: "#139EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_21",
    x1: 73.1099,
    y1: 163.663,
    x2: 220.403,
    y2: 163.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_45_21",
    x1: 29.9009,
    y1: 126.411,
    x2: 45.3766,
    y2: 125.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_45_21",
    x1: 77.2344,
    y1: 53.79,
    x2: 128.947,
    y2: 53.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaadeinBlankLogo);
export default __webpack_public_path__ + "static/media/yaadein_blank_logo.7ba33e19361663c127d5b695f3234aeb.svg";
export { ForwardRef as ReactComponent };